import React, { Component } from 'react';

class Directory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editEntry: false,
            filterBy: {}, sortBy: 'name', sortOrder: 1,
            loading: false
        };
    }
    cancel = () => {
        this.setState({ editEntry: false, loading: false, error: '', alias: '', newAlias: '' })
    }

    editEntry = (entry) => e => {
        this.setState({ editEntry: true, entry: entry, loading: false, error: '' })
    }
    add = () => {
        this.setState({
            editEntry: true,
            entry: {
                "id": generateUniqueId(),
                "name": "",
                "department": "",
                "type": this.state.type,
                "number": "",
                "prompt": "",
                "announceNumber": false,
                "active": true,
                "sayAs": "",
                "alias": [
                ],
                "lastUpdatedUser": ""
            },
            loading: false,
            error: ''
        })
    }
    handleChange = (event) => {
        const { name, type, value, checked } = event.target;
        const newValue = type === "checkbox" ? checked : value;

        let error = '';

        if (name === "number" && isNaN(Number(newValue))) {
            error = 'Not a valid Number.';
        }

        if (name === "name") {
            const entryExists = this.props.data.Directory.entries.some(entry => entry.name === newValue && entry.id !== this.state.entry.id);
            if (entryExists) {
                error = 'This name already exists in the directory.';
            }
        }

        this.setState({
            entry: {
                ...this.state.entry,
                [name]: newValue
            },
            error: error
        });
    };

    confirmEditEntry = () => {
        this.props.ws.send(JSON.stringify({ route: 'editDirectory', entry: this.state.entry }))
        this.setState({ editEntry: false, loading: true, error: '', entry: {}, alias: '', newAlias: '' })
    }
    condifrmDeleteEntry = () => {
        this.props.ws.send(JSON.stringify({ route: 'deleteDirectory', entry: this.state.entry }))
        this.setState({ editEntry: false, loading: true, error: '', entry: {}, alias: '', newAlias: '' })
    }


    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }
    checkType = (e) => {
        console.log(e.target.value)
        this.setState({ type: e.target.value })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }

    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                    return false
                }
            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }

    render() {
        if (this.props.active) {

            //if this.stat.type is empty, set it to user
            if (this.state.type === "" || this.state.type === undefined) {
                this.setState({ type: "User" })
            }


            var entries = JSON.parse(JSON.stringify(this.props.data.Directory.entries));
            //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                entries = this.filterFunc(entries, this.state.filterBy)
            }
            var departmentArray = []
            entries.forEach((entry) => {
                //for each value were type is department, add to array
                if (entry.type === "Department") {
                    departmentArray.push(entry.name)
                }
            })
            //Build a an array of prompts from this.props.data.Prompts.prompts it will be an object with name and id 
            var promptArray = []
            this.props.data.Prompts.prompts.forEach((prompt) => {
                if (prompt.url.english !== undefined) {
                    promptArray.push({
                        name: prompt.name,
                        id: prompt.url.english
                    })
                }
            })



            //Sorting List
            if (this.state.sortBy !== '') {
                entries.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }
            entries = entries.filter((entry) => {
                return entry.type === this.state.type
            })
            var editEntry = ""
            if (this.state.editEntry) {
                var aliasBox = <div style={{ backgroundColor: '#f2f2f2', padding: '10px', borderRadius: '6px' }}>
                    <label htmlFor="aliases" className="form-label" style={{ marginBottom: "10px" }}>Aliases:</label>
                    {this.state.entry.alias.map((alias, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', margin: "2px" }}>
                            <input
                                type="text"
                                value={alias}
                                onChange={(event) => {
                                    const newAliases = [...this.state.entry.alias];
                                    newAliases[index] = event.target.value;
                                    this.setState({ entry: { ...this.state.entry, alias: newAliases } });
                                }}
                                className="form-input"
                                style={{ padding: "4px", marginRight: "8px" }}
                            />
                            <div
                                className="button delete-alias"
                                style={{
                                    width: "5px",
                                    height: "5px",
                                    fontSize: "16px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "#2A6AA9",
                                    color: "#fff",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    marginLeft: "6px"
                                }}
                                onClick={() => {
                                    const newAliases = [...this.state.entry.alias];
                                    newAliases.splice(index, 1);
                                    this.setState({ entry: { ...this.state.entry, alias: newAliases } });
                                }}
                            >
                                X
                            </div>
                        </div>
                    ))}
                    <div style={{ display: 'flex', alignItems: 'center', margin: "2px" }}>
                        <input
                            type="text"
                            placeholder="Add Alias"
                            value={this.state.newAlias}
                            onChange={(event) => this.setState({ newAlias: event.target.value })}
                            className="form-input"
                            style={{ padding: "4px", marginRight: "8px" }}
                        />
                        <div className="button add-alias"
                            onClick={() => {
                                const newAliases = [...this.state.entry.alias, this.state.newAlias];
                                this.setState({ entry: { ...this.state.entry, alias: newAliases }, newAlias: '' });
                            }}
                            style={{
                                width: "5px",
                                height: "5px",
                                fontSize: "16px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#2A6AA9",
                                color: "#fff",
                                borderRadius: "6px",
                                cursor: "pointer",
                                marginLeft: "6px"
                            }}>Add</div>
                    </div>
                </div >

                editEntry = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <h3>{this.state.entry.type + " Entry"}</h3>

                            <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr", gridGap: "8px", padding: "1px" }}>
                                <label htmlFor="name" className="form-label" style={{ marginBottom: "4px" }}>Name:</label>
                                <input type="text" id="name" name="name" value={this.state.entry.name} onChange={this.handleChange} className="form-input" style={{ padding: "4px" }} />
                                {this.state.entry.type === "User" && (
                                    <>
                                        <label htmlFor="department" className="form-label" style={{ marginBottom: "4px" }}>Department:</label>
                                        <select id="department" name="department" value={this.state.entry.department} onChange={this.handleChange} className="form-input" style={{ padding: "4px" }}>
                                            <option value="">Select a department</option>
                                            {departmentArray.map((dept) => (
                                                <option key={dept} value={dept}>{dept}</option>
                                            ))}
                                        </select>
                                    </>
                                )}
                                {this.state.entry.type === "Topic" && (
                                    <>
                                        <label htmlFor="topic" className="form-label" style={{ marginBottom: "4px" }}>Topic:</label>
                                        <select id="prompt" name="prompt" value={this.state.entry.prompt} onChange={this.handleChange} className="form-input" style={{ padding: "4px" }}>
                                            <option value="">Select a topic</option>
                                            {promptArray.map((prompt) => (
                                                <option key={prompt.id} value={prompt.id}>{prompt.name}</option>
                                            ))}
                                        </select>
                                    </>
                                )}
                                {this.state.entry.type !== "Topic" && (
                                    <>
                                        <label htmlFor="sayAs" className="form-label" style={{ marginBottom: "4px" }}>Say As:</label>
                                        <input type="text" id="sayAs" name="sayAs" value={this.state.entry.sayAs} onChange={this.handleChange} className="form-input" style={{ padding: "4px" }} />

                                        <label htmlFor="number" className="form-label" style={{ marginBottom: "4px" }}>Number:</label>
                                        <input type="text" id="number" name="number" value={this.state.entry.number} onChange={this.handleChange} className="form-input" style={{ padding: "4px" }} />
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            <label htmlFor="announceNumber" className="form-label" style={{ marginBottom: "4px" }}>Announce Number:</label>
                                            <input type="checkbox"
                                                id="announceNumber"
                                                name="announceNumber"
                                                checked={this.state.entry.announceNumber}
                                                onChange={this.handleChange}
                                                className="form-input"
                                                style={{
                                                    padding: "4px",
                                                    width: "20px", /* adjust width to desired size */
                                                    height: "20px", /* adjust height to desired size */
                                                    marginLeft: "10px", /* adjust margin to desired distance from label */
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <label htmlFor="active" className="form-label" style={{ marginBottom: "4px" }}>Active:</label>
                                    <input type="checkbox"
                                        id="active"
                                        name="active"
                                        checked={this.state.entry.active}
                                        onChange={this.handleChange}
                                        className="form-input"
                                        style={{
                                            padding: "4px",
                                            width: "20px", /* adjust width to desired size */
                                            height: "20px", /* adjust height to desired size */
                                            marginLeft: "10px", /* adjust margin to desired distance from label */
                                        }}
                                    />
                                </div>

                            </div>
                            <br />
                            {aliasBox}
                            <br />
                            <div className="error">{this.state.error}</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="button confirm" onClick={this.confirmEditEntry} title="Confirm Changes">
                                    Confirm
                                </div>
                                {!this.state.entry.system && (
                                    <div className="button delete" onClick={this.condifrmDeleteEntry} style={{ backgroundColor: '#c0392b' }} title="Delete Entry">
                                        Delete
                                    </div>

                                )}


                            </div>
                            {this.state.entry.system && (
                                <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>This entry is built into the system and cannot be removed</div>
                            )}
                        </div>
                    </div>
                );
            }

            var entryList = []
            var tableHeaders = ""
            if (this.state.type === "User") {
                tableHeaders = (<tr className="dataRow">
                    <th style={{ minWidth: '400px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
                    <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("number")}>Number {this.filterIcon("number")}</th>
                    <th style={{ minWidth: '200px', maxWidth: '200px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("department")}>Department {this.filterIcon("department")}</th>
                </tr>)
                for (var entry of entries) {
                    entryList.push(
                        <tr className="dataRow" onClick={this.editEntry(JSON.parse(JSON.stringify(entry)))} key={entry.id}>
                            <td style={{ minWidth: '400px', textAlign: 'left' }}>{entry.name}</td>
                            <td style={{ minWidth: '200px', textAlign: 'left' }}>{entry.number}</td>
                            <td style={{ minWidth: '200px', maxWidth: '200px', textAlign: 'right' }}>{entry.department}</td>
                        </tr>
                    );
                }
            } else if (this.state.type === "Department") {
                tableHeaders = (<tr className="dataRow">
                    <th style={{ minWidth: '400px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
                    <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("number")}>Number {this.filterIcon("number")}</th>
                    <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'center' }} onClick={this.sort("system")}>System {this.filterIcon("system")}</th>
                </tr>)
                for (var entry of entries) {
                    entryList.push(
                        <tr className="dataRow" onClick={this.editEntry(JSON.parse(JSON.stringify(entry)))} key={entry.id}>
                            <td style={{ minWidth: '400px', textAlign: 'left' }}>{entry.name}</td>
                            <td style={{ minWidth: '200px', textAlign: 'left' }}>{entry.number}</td>
                            <td style={{ minWidth: '200px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {entry.system ?
                                    <div style={{
                                        backgroundColor: '#2A6AA9',
                                        color: 'white',
                                        borderRadius: '50%',
                                        height: '20px',
                                        width: '20px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <svg width="10" height="8" viewBox="0 0 10 8">
                                            <path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
                                        </svg>
                                    </div>
                                    : null
                                }
                            </td>
                        </tr>
                    );
                }
            } else if (this.state.type === "Topic") {
                tableHeaders = (<tr className="dataRow">
                    <th style={{ minWidth: '600px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
                    <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'center' }} onClick={this.sort("system")}>System {this.filterIcon("system")}</th>
                </tr>)
                for (var entry of entries) {
                    entryList.push(
                        <tr className="dataRow" onClick={this.editEntry(JSON.parse(JSON.stringify(entry)))} key={entry.id}>
                            <td style={{ minWidth: '600px', textAlign: 'left' }}>{entry.name}</td>
                            <td style={{ minWidth: '200px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {entry.system ?
                                    <div style={{
                                        backgroundColor: '#2A6AA9',
                                        color: 'white',
                                        borderRadius: '50%',
                                        height: '20px',
                                        width: '20px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <svg width="10" height="8" viewBox="0 0 10 8">
                                            <path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
                                        </svg>
                                    </div>
                                    : null
                                }
                            </td>
                        </tr>
                    );
                }
            }
            var addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a User" onClick={this.add} />

            return (
                <div width="100%">
                    {addButton}
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '280px', marginRight: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
                                <label className="switch">
                                    <div style={{ width: '250px' }}>
                                        <select value={this.state.type} onChange={this.checkType} style={{ display: 'inline-block', flex: '1 0 0', marginBottom: '5px', height: '40px', padding: '0 10px', border: '1px solid #ddd', borderRadius: '4px', fontWeight: 'bold', fontSize: '20px', color: '#137', lineHeight: '24px' }}>
                                            <option value="User">Users</option>
                                            <option value="Department">Departments</option>
                                            <option value="Topic">Topics</option>
                                        </select>
                                    </div>


                                </label>
                            </div>
                            <div className="filterBox">
                                <h4>Filter By:</h4>
                                <div>
                                    <label>Name:</label>
                                    <input type="text" onChange={this.filter("name")} value={this.state.filterBy.name} />
                                </div>
                                {this.state.type === "User" &&
                                    <div>
                                        <label>Department:</label>
                                        <input type="text" onChange={this.filter("department")} value={this.state.filterBy.department} style={{ width: '120px' }} />
                                    </div>
                                }
                                {this.state.type !== "Topic" &&
                                    <div>
                                        <label>Number:</label>
                                        <input type="text" onChange={this.filter("number")} value={this.state.filterBy.number} style={{ width: '150px' }} />
                                    </div>
                                }
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <table>
                                <thead>
                                    {tableHeaders}
                                </thead>
                                <tbody>
                                    {entryList}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {editEntry}
                </div>
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}

const icon = "menuWorkflow"
const roles = ["View"]
export { Directory, icon, roles }




function generateUniqueId() {
    const timestamp = Date.now().toString(36);
    const randomStr = Math.random().toString(36).slice(2);
    const uniqueId = timestamp + randomStr;
    return uniqueId;
}